import { render, staticRenderFns } from "./CPublicCorporationProfilePage.vue?vue&type=template&id=7d620891&"
import script from "./CPublicCorporationProfilePage.vue?vue&type=script&lang=ts&"
export * from "./CPublicCorporationProfilePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports